import { render, staticRenderFns } from "./ImportContainer.vue?vue&type=template&id=4c3b5986"
import script from "./ImportContainer.vue?vue&type=script&lang=js"
export * from "./ImportContainer.vue?vue&type=script&lang=js"
import style0 from "./ImportContainer.vue?vue&type=style&index=0&id=4c3b5986&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../.worktrees/accreditations-staging-e2e-fix/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports